import React from 'react'
import { Route, Routes, useLocation } from "react-router-dom";

import Wraper from '../Components/Dashboard/Wraper/Wraper';
import Dashboard from '../layout/User/Dashboard/Dashboard';
import Signals from '../layout/User/Signals/Signals';
import TradingStatus from '../layout/User/Trading status/Tradingstatus';
import Profile from '../layout/User/Profile/Profile';
import BrokerResponse from '../layout/User/BrokerResponse/BrokerResponse';
import TradeHistory from '../layout/User/TradeHistory/TradeHistory';
import ApiCreateInfo from '../layout/User/ApiCreateInfo/ApiCreateInfo';
import HelpCenter from '../layout/User/HelpCenter/HelpCenter';
import StrategyDesc from '../layout/User/StrategyDesc/StrategyDesc';
import CoinDCXGuide from '../layout/User/ApiCreateInfo/CoinDCXGuide';
import Deltaexchange from '../layout/User/ApiCreateInfo/Deltaexchange';
import Pi42 from '../layout/User/ApiCreateInfo/Pi42';
import Setting from '../layout/User/Profile/Setting';

// OPTION CHAIN
import Userreferal from '../layout/User/Profile/ReferralPage';
import Faq from '../layout/Admin/Faq/Faq';
import Wallet from '../layout/User/wallet/Wallet';
import Binance from '../layout/User/ApiCreateInfo/Binance';

import Stocks from "../layout/User/Dashboard/Stocks"
import CoinSwitch from '../layout/User/ApiCreateInfo/CoinSwitch';
import Tutorials from '../layout/User/Tutorials/Tutorials';
import Backtesting from '../layout/User/Backtesting/Backtesting';




// strategydesc
const Admin = () => {

    const location = useLocation();


    return (
        <>
            {location.pathname !== "/client" && location.pathname !== "/client/*" ? <Wraper /> : null}

            <Routes>
                <Route exact path="/stocks" element={<Stocks />} />
                <Route exact path="/dashboard" element={<Dashboard />} />

                <Route exact path="/signals" element={<Signals />} />
                <Route exact path="/tradingstatus" element={<TradingStatus />} />
                <Route exact path="/profile" element={<Profile />} />
                <Route exact path="/brokerresponse" element={<BrokerResponse />} />
                <Route exact path="/tradehistory" element={<TradeHistory />} />
                <Route exact path="/apicreateinfo" element={<ApiCreateInfo />} />
                <Route exact path="/helpcenter" element={<HelpCenter />} />
                <Route exact path="/strategydesc" element={<StrategyDesc />} />
                <Route exact path="/apicreateinfo/coinDCXGuide" element={<CoinDCXGuide />} />
                <Route exact path="/apicreateinfo/Deltaexchange" element={<Deltaexchange />} />
                <Route exact path="/apicreateinfo/binance" element={<Binance />} />
                <Route exact path="/apicreateinfo/CoinSwitchGuide" element={<CoinSwitch />} />
                <Route exact path="/apicreateinfo/Pi42" element={<Pi42 />} />

                <Route exact path="/Setting" element={<Setting />} />

                <Route exact path="/refer-earn" element={<Userreferal />} />
                <Route exact path="/faq" element={<Faq />} />
                <Route exact path="/wallet" element={<Wallet />} />
                <Route exact path="/tutorials" element={<Tutorials />} />
                <Route exact path="/backtesting" element={<Backtesting />} />



            </Routes>


        </>
    )
}
export default Admin
